<template>
  <DefaultBackground>
    <section class="m-2 md:m-10">
      <div class="container mx-auto">

        <!-- Companies List -->
        <CompaniesList v-if="!epUUID" :companies="companies" />

        <!-- Dashboard -->
        <template v-else>
          <div v-if="ep" class="grid grid-cols-12 gap-6 mx-auto">
            <div class="col-span-12 lg:col-span-8 xl:col-span-9">

              <div v-if="ep.status == 'pending'" class="bg-yellow-500 rounded-lg shadow-card mx-auto mb-6 p-4  text-semibold">
                This Account is Under Review and Will Be Active Upon Verification
              </div>

              <!-- Territories table -->
              <div class="bg-white rounded-lg shadow-card mx-auto mb-6">
                <header class="flex flex-col md:flex-row justify-between px-6 py-4">
                  <h2 class="font-semibold text-2xl lg:text-2xl py-2">
                    Territories
                  </h2>

                  <a @click="$router.push({name: 'event-planner.signup.details'})" class="btn btn-secondary font-semibold rounded-lg px-4 truncate">Add and Remove Territory Advertising</a>
                </header>
                <div>
                  <table class="table-fixed text-left w-full text-sm">
                    <thead class="hidden md:table-header-group">
                    <tr class="border-t border-b border-light-gray px-6 py-4">
                      <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">POSTAL CODE</span>
                      </th>
                      <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">PRICE</span>
                      </th>
                      <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">PAID TO</span>
                      </th>
                      
                    </tr>
                    </thead>
                    <tbody v-if="locations && locations.length > 0">
                    <tr v-for="location in locations" :key="location.id" class="border-t border-light-gray">
                      <td class="block md:table-cell px-6 py-4 md:py-5">
                        <div class="md:hidden text-dark-gray mb-2">
                          POSTAL CODE
                        </div>
                        <div>{{ location.location }}</div>
                      </td>
                      <td class="block md:table-cell px-6 py-4 md:py-5">
                        <div class="md:hidden text-dark-gray mb-2">
                          PRICE
                        </div>
                        <div>{{ location.price | currencyFormat }}</div>
                      </td>
                      <td class="block md:table-cell px-6 py-4 md:py-5">
                        <div class="md:hidden text-dark-gray mb-2">
                          PAID TO
                        </div>
                        <div>{{ location | paidTo }}</div>
                      </td>
                    </tr>
                    </tbody>

                    <tbody v-else-if="!loading">
                    <tr class="border-t border-light-gray">
                      <td colspan="3" class="px-6 py-4">
                        <div class="text-center text-white opacity-30 p-4 bg-green-500">
                          You do not have any Territories.
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              
              <!-- EVENTS TABLE -->
              <div class="bg-white rounded-lg shadow-card mx-auto mb-6">
                <header class="flex flex-col md:flex-row justify-between px-6 py-4">
                  <h2 class="font-semibold text-2xl lg:text-2xl py-2">
                    Served Events
                  </h2>
                </header>
                <div>
                  <table class="table-fixed text-left w-full text-sm">
                    <thead class="hidden md:table-header-group">
                    <tr class="border-t border-b border-light-gray px-6 py-4">
                      <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">EVENT NAME</span>
                      </th>
                      <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">EVENT STATUS</span>
                      </th>
                      <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">EVENT DATE</span>
                      </th>
                      <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">OWNER PHONE</span>
                      </th>
                      <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">OWNER NAME</span>
                      </th>
                      <th class="w-2/12 px-6 py-3">

                      </th>
                    </tr>
                    </thead>
                    <tbody v-if="events.length > 0">
                    <tr v-for="event in events" :key="event.id" class="border-t border-light-gray">
                      <td class="block md:table-cell px-6 py-4 md:py-5">
                        <div class="md:hidden text-dark-gray mb-2">
                          EVENT NAME
                        </div>
                        <div>{{ event.name }}</div>
                      </td>
                      <td class="block md:table-cell px-6 py-4 md:py-5">
                        <div class="md:hidden text-dark-gray mb-2">
                          EVENT STATUS
                        </div>
                        <div>{{ event.status }}</div>
                      </td>
                      <td class="block md:table-cell px-6 py-4 md:py-5">
                        <div class="md:hidden text-dark-gray mb-2">
                          EVENT DATE
                        </div>
                        <div>{{ getEventDate(event.date) }}</div>
                      </td>
                      <td class="block md:table-cell px-6 py-4 md:py-5">
                        <div class="md:hidden text-dark-gray mb-2">
                          OWNER PHONE
                        </div>
                        <div>{{ event.phone }}</div>
                      </td>
                      <td class="block md:table-cell px-6 py-4 md:py-5">
                        <div class="md:hidden text-dark-gray mb-2">
                          OWNER NAME
                        </div>
                        <div>{{ event.owner }}</div>
                      </td>
                      <td class="block md:table-cell px-6 py-4 md:py-5">
                        <div class="flex flex-col sm:flex-row md:justify-end">
                          <router-link
                            :to="`/orders/${event.uuid}`" class="w-full md:w-32"
                          >
                            <button class="btn btn-secondary font-semibold rounded-lg w-full px-2 truncate">
                              View Details
                            </button>
                          </router-link>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                    <tbody v-else-if="!loading">
                    <tr class="border-t border-light-gray">
                      <td colspan="6" class="px-6 py-4">
                        <div class="text-center text-white opacity-30 p-4 bg-green-500">
                          You do not have any Events.
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- PAYMENTS -->
              <div class="bg-white rounded-lg shadow-card mx-auto mb-6">
                <header class="flex flex-col md:flex-row justify-between px-6 py-4">
                  <h2 class="font-semibold text-2xl lg:text-2xl py-2">
                    Payments
                  </h2>
                </header>
                <div>
                  <table class="table-fixed text-left w-full text-sm">
                    <thead class="hidden md:table-header-group">
                    <tr class="border-t border-b border-light-gray px-6 py-4">
                      <th class="px-6 py-3w-1/2 w-1/2">
                        <span class="text-dark-gray font-normal">TRANSACTION ID</span>
                      </th>
                      <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">PAYMENT DATE</span>
                      </th>
                      <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">AMOUNT</span>
                      </th>
                      <th class="px-6 py-3">
                        <span class="text-dark-gray font-normal">STATUS</span>
                      </th>
                    </tr>
                    </thead>
                    <tbody v-if="ep.payments && ep.payments.length > 0">
                    <tr v-for="payment in ep.payments" :key="payment.transaction_id" class="border-t border-light-gray">
                      <td class="block md:table-cell px-6 py-4 md:py-8">
                        <div class="md:hidden text-dark-gray mb-2">
                          TRANSACTION ID
                        </div>
                        <div>{{ payment.transaction_id }}</div>
                      </td>
                      <td class="block md:table-cell px-6 py-4 md:py-8">
                        <div class="md:hidden text-dark-gray mb-2">
                          PAYMENT DATE
                        </div>
                        <div>{{ getEventDate(payment.date) }}</div>
                      </td>
                      <td class="block md:table-cell px-6 py-4 md:py-8">
                        <div class="md:hidden text-dark-gray mb-2">
                          AMOUNT
                        </div>
                        <div>${{ payment.total }}</div>
                      </td>
                      <td class="block md:table-cell px-6 py-4 md:py-8">
                        <div class="md:hidden text-dark-gray mb-2">
                          STATUS
                        </div>
                        <div>{{ payment.status }}</div>
                      </td>
                    </tr>
                    </tbody>
                    <tbody v-else-if="!loading">
                    <tr class="border-t border-light-gray">
                      <td colspan="4" class="px-6 py-4">
                        <div class="text-center text-white opacity-30 p-4 bg-green-500">
                          You do not have any Payments.
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- MENU -->
              <div class="bg-white rounded-lg shadow-card mx-auto">
                <header class="flex flex-col md:flex-row justify-between items-center px-6 py-4">
                  <h2 class="font-semibold text-2xl lg:text-2xl py-2">
                    Products and Services
                  </h2>

                  <router-link :to="{ name: 'event-planner.signup.details' }" class="text-sm">
                      <span class="edit-link text-primary bg-white py-1 px-3 border rounded opacity-50 hover:opacity-100">edit</span>
                  </router-link>
                </header>
                <div v-if="categories && categories.length > 0">
                  <div v-for="(category, index) in categories" :key="category.uuid"
                      :class="{'border-b border-gray-300': index < categories.length - 1}"
                      class="px-3 py-5">
                    <div class="flex flex-row items-center px-2 md:px-4 group">
                      <div
                        class="w-12 h-12 rounded bg-gray-600 overflow-hidden flex items-center justify-center flex-shrink-0">
                        <img :src="category.image" alt="Order Details Page" />
                      </div>
                      <div class="ml-4 min-w-0">
                        <div class="flex items-center">
                          <div class="font-semibold text-primary">
                            {{ category.name }}
                          </div>
                        </div>
                        <div class="text-gray-600 mt-1">{{ category.description }}</div>
                      </div>
                    </div>
                    <div class="mt-4 md:ml-10">
                      <div v-if="category.items && category.items.length > 0" class="">
                        <div v-for="item in category.items" :key="item.uuid" class="line-item">
                          <div class="flex flex-row items-center py-4 group">
                            <div class="btn ml-3 draggable-handler mr-4 flex-shrink-0"></div>
                            <div
                              class="w-12 h-12 rounded bg-gray-600 overflow-hidden flex items-center justify-center flex-shrink-0">
                              <img :src="item.image" alt="BuildaBox Order Details Page" />
                            </div>
                            <div class="ml-4 min-w-0">
                              <div class="flex items-center">
                                <div class="font-semibold">
                                  {{ item.name }}
                                </div>
                              </div>
                              <div class="text-gray-600 mt-1">{{ item.description }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="text-center text-gray-600 my-2 p-5"></div>
                    </div>
                  </div>
                </div>
                <div class="p-6" v-else>
                  <div class="text-center text-white opacity-30 p-4 bg-green-500">
                    You do not have any menu items.
                  </div>
                </div>
              </div>
            </div>


            <!-- Right Panel -->
            <div class="col-span-12 lg:col-span-4 xl:col-span-3">
              <div class="bg-white rounded-lg shadow-card mx-auto px-6 py-6 mb-6">
                
                <CustomDropDown
                  class="mb-3 leading-none"
                  @onChanged="companyChanged"
                  :dataset="companies"
                  displayKey="name"
                  :label="ep.name"
                  size="2xl"
                />

                <div class="mb-8 relative">
                  <img :src="ep.logo" :alt="ep.name">

                  <router-link :to="{ name: 'event-planner.signup.details' }" class="text-sm">
                      <span style="right: 10px; top: 10px;" class="edit-link text-primary bg-white py-1 px-2 absolute rounded opacity-50 hover:opacity-100">edit</span>
                  </router-link>

                </div>
                <div class="ep-info mb-8">
                  <div class="flex justify-between content-center">
                    <div class="text-lg font-semibold mb-2">Description</div>
                    <router-link :to="{ name: 'event-planner.signup.details' }" class="text-sm">
                      <span class="edit-link text-primary">edit</span>
                    </router-link>
                  </div>
                  <div class="text-sm">
                    {{ ep.description }}
                  </div>
                </div>
                <div class="ep-info mb-8">
                  <div class="flex justify-between content-center">
                    <div class="text-lg font-semibold mb-2">Services</div>
                    <router-link :to="{ name: 'event-planner.signup.details' }" class="text-sm">
                      <span class="edit-link text-primary">edit</span>
                    </router-link>
                  </div>
                  <div class="tags flex flex-wrap -m-1">
                    <span v-for="type in ep.services" :key="type.id" class="m-1">
                      {{ type.name }}
                    </span>
                  </div>
                </div>
                <div class="ep-info mb-8">
                  <div class="flex justify-between content-center">
                    <div class="text-lg font-semibold mb-2">Contact Person</div>
                    <router-link :to="{ name: 'event-planner.signup.details' }" class="text-sm">
                      <span class="edit-link text-primary">edit</span>
                    </router-link>
                  </div>
                  <div class="text-sm">
                    {{ ep.contact_first_name }} {{ ep.contact_last_name }}
                  </div>
                </div>
                <div class="ep-info mb-8">
                  <div class="flex justify-between content-center">
                    <div class="text-lg font-semibold mb-2">Address</div>
                    <router-link :to="{ name: 'event-planner.signup.details' }" class="text-sm">
                      <span class="edit-link text-primary">edit</span>
                    </router-link>
                  </div>
                  <div class="text-sm">
                    {{ ep.address }}
                  </div>
                </div>
                <div class="ep-info mb-8">
                  <div class="flex justify-between content-center">
                    <div class="text-lg font-semibold mb-2">State</div>
                    <router-link :to="{ name: 'event-planner.signup.details' }" class="text-sm">
                      <span class="edit-link text-primary">edit</span>
                    </router-link>
                  </div>
                  <div class="text-sm">
                    {{ ep.state }}
                  </div>
                </div>
                <div class="ep-info mb-8">
                  <div class="flex justify-between content-center">
                    <div class="text-lg font-semibold mb-2">Zip</div>
                    <router-link :to="{ name: 'event-planner.signup.details' }" class="text-sm">
                      <span class="edit-link text-primary">edit</span>
                    </router-link>
                  </div>
                  <div class="text-sm">
                    {{ ep.zip }}
                  </div>
                </div>
                <div class="ep-info">
                  <div class="flex justify-between content-center">
                    <div class="text-lg font-semibold mb-2">Phone</div>
                    <router-link :to="{ name: 'event-planner.signup.details' }" class="text-sm">
                      <span class="edit-link text-primary">edit</span>
                    </router-link>
                  </div>
                  <div class="text-sm">
                    {{ ep.phone }}
                  </div>
                </div>
              </div>

            
            </div>
          </div>
        </template>

      </div>
    </section>
  </DefaultBackground>
</template>

<script>
import DefaultBackground from "@/components/common/layout/DefaultBackground";
import Api from "@/api/api_v1.0"
import moment from "moment";
import CompaniesList from "@/components/event-planner/CompaniesListComponent";
import CustomDropDown from "../../components/common/controls/CustomDropDown.vue";

export default {
  name: "EventPlannerDashboard",

  components: {
    DefaultBackground,
    CompaniesList,
    CustomDropDown
  },

  data() {
    return {
      loading: true,
      companies: [],
      ep: null,
      events: [],
      categories: [],
      locations: [],
    }
  },

  async created() {
    await this.getUserEventPlanners();
    
    if (this.epUUID) {
      this.initDashboard();
    }
    
  },

  watch: {
    epUUID(uuid) {
      if(uuid) {
        this.initDashboard();
      }
    }
  },

  methods: {
    companyChanged(data) {
      this.$router.push({
        name: "event-planner.dashboard",
        params: { uuid: data.uuid }
      });
    },

    async getUserEventPlanners() {
      const response = await Api.getMyEventPlannerCompanies();
      this.companies = response.data;
    },

    async initDashboard() {
        await this.getEPInfo();
        await this.getCategories();
        await this.getLocationsPrice();
        await this.getEvents();
    },

    async getCategories() {
      const result = await Api.getEventPlannerCategories(this.ep.id);
      this.categories = result.data;
    },

    async onRemoveLocation(location) {
      const modal = await this.$swal({
        title: "Confirm remove record?",
        showCancelButton: true,
        confirmButtonText: 'Remove',
      });

      if(modal.isConfirmed) {
        this.removeLocation(location);
      }
    },

    removeLocation(location) {
      Api.removeEventPlannerLocation(this.ep.id, location);

      const index = this.locations.indexOf(this.locations.find( item => {
        return item.text == location
      }));

      this.locations.splice(index, 1);
    },

    async getEPInfo() {
      const response = await Api.getMyBusinessEventPlannerDetails(this.epUUID);
      this.ep = response.data;
      
      this.loading = false
    },

    async getEvents() {
      try {
        const response = await Api.getEventPlannerEvents(this.ep.id);
        this.events = response.data
      } catch (e) {
        console.error(e)
      }
    },


    async getLocationsPrice() {
      try {
        const response = await Api.getEventPlannerLocationsPrice({
          locations: this.ep.service_zip_codes.map(zip => zip.text),
          event_planner_id: this.ep.id
        });

        this.locations = response.data.prices;
      } catch (e) {
        console.error(e)
      }
    },

    getEventDate(date) {
      if (date) {
        return moment(date).format('MMM DD, YYYY')
      } else {
        return ''
      }
    },
  },

  filters: {
    paidTo(location) {
      if(location.price == 'free') {
        return 'No Charge';
      } else {
        return location.paid_at == undefined ? 'Unpaid' : moment(location.paid_at).add(30, 'days').format('D MMM, Y');
      }
    }
  },

  computed: {
    zipCodesPriceFormatted() {
      return this.locationPrices && this.locationPrices.total > 0 ? '$' + this.locationPrices.total : 'free';
    },
    epUUID() {
      return this.$route.params.uuid ?? false;
    },
  }
}
</script>

<style lang="scss" scoped>
.tags {
  span {
    display: inline-block;
    background-color: #f35e38;
    border-radius: 4px;
    color: #fff;
    padding: 3px 5px;
    font-size: .85em;
  }
}

.ep-info {
  .edit-link {
    opacity: 0.5;
  }

  &:hover {
    .edit-link {
      opacity: 1;
    }
  }
}
</style>
